<!-- <div class="custom-slider" *ngIf="startSlider"> -->

	<!-- <ngx-slider [(ngModel)]="value" (mouseup)="testF(value)" [(highValue)]="highValue" [options]="options"></ngx-slider>
</div> -->


	<div  [class.disabled-filters]="!startSlider" class="filter-title floor-title">{{ 'FLOOR' | translate }}:</div>
	<div [class.disabled-filters]="!startSlider" class="custom-slider">
		<!-- <p>Value: {{value}}</p>
		<p>Value: {{highValue}}</p>
		<input type="text" [(ngModel)]="highValue" (change)="testF(highValue, 'last')">
		<input type="text" [(ngModel)]="value" (change)="testF(value, 'first')"> -->
		<ngx-slider [(ngModel)]="value" (mouseup)="testF(value)" [(highValue)]="highValue" [options]="options"></ngx-slider>
	</div>
	
